export const ProjectGeneralInfo = {
  MIDTERM_SUMMARY_REPORT: 'midtermSummaryReport',
  MIDTERM_COUNCIL: 'midtermCouncil',
  FINANCIAL_ADJUSTMENT: 'financialAdjustment',
  EXTEND_IMPLEMENTATION_TIME: 'extendImplementationTime',
  PERSONNEL_ADJUSTMENT: 'personnelAdjustment',
  ACCEPTANCE_SUMMARY_REPORT: 'acceptanceSummaryReport',
  ACCEPTANCE_COUNCIL: 'acceptanceCouncil',
  REGISTER_RESULT: 'registerResult',
  LIQUIDATION: 'liquidation',
  LIQUIDATION_SUMMARY_REPORT: 'liquidationSummaryReport',
  LIQUIDATION_COUNCIL: 'liquidationCouncil',
};

const SummaryReportFilters = [
  { name: 'notSubmitted', code: 'notSubmitted' },
  { name: 'submitted', code: 'submitted' },
  { name: 'submittedHasResult', code: 'submittedHasResult' },
];

const Project = {
  ProjectGeneralInfo,
  SummaryReportFilters,
};

export default Project;
